import { computed, Ref, unref } from 'vue';
import { skipToken, useQuery } from '@tanstack/vue-query';
import { getAvailableScans } from './scan.endpoints';

export function useFetchAvailableScans(enabledRef: Ref<boolean>) {
  return useQuery({
    queryKey: ['availableScans'],
    queryFn: computed(() => {
      if (!unref(enabledRef)) return skipToken;
      return () => getAvailableScans();
    }),
  });
}
